<template>
  <div id="app">
    <navbar />
    <main>
      <slot> <router-view /></slot>
    </main>
  </div>
</template>

<script>
import Navbar from './components/Navbar';
export default {
  name: 'App',
 components: { Navbar },
}
</script>

<style lang="scss">
@import "./sass/global.scss";
@import url("https://fonts.googleapis.com/css2?family=Calligraffitti&family=Quicksand&family=Pinyon+Script&display=swap");
#app {
  transition: background 1s, color 1s;
  -webkit-transition: background 1s, color 1s;
}
</style>
